import { Injectable } from '@angular/core';
import { CustomFacetContentType, CustomProductSearchPage } from '@catalog/const';
import { Converter } from '@spartacus/core';

@Injectable({ providedIn: 'root' })
export class ProductSearchBreadcrumbsNormalizer implements Converter<
  CustomProductSearchPage,
  Partial<CustomProductSearchPage>
> {
  convert(source: CustomProductSearchPage, target?: CustomProductSearchPage): Partial<CustomProductSearchPage> {
    if (target === undefined) {
      target = { ...(source as any) };
    }

    if (source.breadcrumbs.length > 0) {
      target.breadcrumbs = source.breadcrumbs.map((crumb) => {
        // заполняем пустые contentType
        if (!crumb.contentType && !['allCategories', 'allCampaigns'].includes(crumb.facetCode)) {
          return { ...crumb, contentType: CustomFacetContentType.Checkbox };
        }

        return crumb;
      });
    }

    return target;
  }
}
